import { COLORS } from "../../common/constants";

export const styles = {
  mainContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
  },
  mainInnerContainer: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: COLORS.mainContainerBg,
  },
  mainRightContainer: {
    width: "100%",
    // marginLeft: "80px",
    marginTop: "75px",
    // minHeight: "calc(100vh - 75px)",
  },
};
